import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m19.3 8.925-4.25-4.2 1.4-1.4a1.92 1.92 0 0 1 1.413-.575 1.92 1.92 0 0 1 1.412.575l1.4 1.4c.383.383.583.846.6 1.388a1.807 1.807 0 0 1-.55 1.387L19.3 8.925ZM4 21a.967.967 0 0 1-.712-.288A.968.968 0 0 1 3 20v-2.825c0-.133.025-.262.075-.387a.999.999 0 0 1 .225-.338l10.3-10.3 4.25 4.25-10.3 10.3a.997.997 0 0 1-.725.3H4Z" }, null, -1)
  ])))
}
export default { render: render }